// The one way the app copies text to the clipboard. It says whether the
// browser took it, and never throws: a refusal (a denied permission, an
// insecure origin with no clipboard at all) is `false`, which each caller
// tells in its own words.
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
